var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[(_vm.user.role.id == 0 || _vm.user.role.id == 2)?_c('ForUser'):(_vm.user.role.id == 1)?_c('ForAccount'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }